import React, { useState } from 'react'
import { Table } from '../../../admin/components/Table/Table'
import Button from '../../../utils/components/Button/Button'
import File from '../../../utils/components/File/File'

const InventoryListView = ({ products,cataloge,setCataloge,loadCataloge }) => {
   
    return (
        <div>
            <div>
            <File
                name="cataloge"
                accept={".pdf"}
                text={cataloge ? "Archivo cargado" : "*Cargue el catalogo"}
                onChange={(e) => {
                    if(e.target.files[0] && e.target.files[0].type.includes('pdf')){
                        setCataloge(e.target.files[0] )
                    }
                }}
            />
            <Button text='Subir' onClick={e =>loadCataloge()}/>

            </div>
          
            <Table>
                <thead>
                    <tr>
                        <th>Producto</th>
                        <th>Cantidad en stock</th>
                        <th>Cantidad separada</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        products.map(product => (
                            <tr key={product._id}>
                                <td>{product.productId.name}</td>
                                <td>{product.stocks}</td>
                                <td>{product.separated}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
        </div>
    )
}

export default InventoryListView